import { useCookies } from "vue3-cookies"
import { GetApiUrl } from '../helpers/apiBaseUrl.js'
import 'dotenv/config'
export default function Auth({ next, to }) {
    const { cookies } = useCookies()
    const code = to.query._reqUzcode
    if(code){
        const requestedRoute = cookies.get('_redirreq') || to.path || '/'
        cookies.set('_auzer', 'checker','1d','/','',true,'Strict')
        cookies.remove('_redirreq')
        return next(requestedRoute)
    }

    if(!cookies.get('_auzer')){
        cookies.set('_redirreq', to.fullPath ,'15min','/','',true,'Strict')
        const boqOrigin = process.env.VUE_APP_BOQ_URL || window.location.origin
        window.location.assign(GetApiUrl("/api/auth/sso?origin="+encodeURIComponent(boqOrigin)))
        return
    }

    return next()
}
